module.exports = __webpack_public_path__ + "img/image001.e26618be.png";